module.exports = __webpack_public_path__ + "img/f6-2.0f459030.jpg";